// extracted by mini-css-extract-plugin
export default {"items":"About_items__B0u3O","item":"About_item__-ZPLR","icon":"About_icon__gIc3F","contant":"About_contant__kah5h"};